import { Button } from '@material-ui/core';
import React from 'react';
import variables from '../../../utils/variables';
import * as PropTypes from 'prop-types';
import background from '../../../assets/infrastructure/background.svg';
import logo1 from '../../../assets/infrastructure/logo1.svg';
import logo2 from '../../../assets/infrastructure/logo2.svg';
import logo3 from '../../../assets/infrastructure/logo3.svg';
import logo4 from '../../../assets/infrastructure/logo4.svg';
import './index.css';
import Icon from '../../../components/Icon';

const Infrastructure = (props) => {
    const handleClick = () => {
        window.open('https://docs.omniflix.network/stakeholders/node-hosts', '_blank');
    };

    return (
        <section className="infrastructure" id="infrastructure">
            <div className="heading">
                <h2>{variables[props.lang].infrastructure}</h2>
                <span/>
                <p>{variables[props.lang]['infrastructure_info']}</p>
            </div>
            <img
                alt={variables[props.lang].infrastructure}
                className="background"
                src={background}/>
            <div className="cards_row">
                <div className="row">
                    <div className="card">
                        <div className="left_content">
                            <p className="heading_text">
                                {variables[props.lang]['infrastructure_card1_heading']}
                            </p>
                            <p>{variables[props.lang]['infrastructure_card1_text1']}</p>
                            <p>{variables[props.lang]['infrastructure_card1_text2']}</p>
                            <p>{variables[props.lang]['infrastructure_card1_text3']}</p>
                        </div>
                        <img alt={variables[props.lang]['infrastructure_card1_heading']} src={logo1}/>
                    </div>
                    <div className="card">
                        <div className="left_content">
                            <p className="heading_text">
                                {variables[props.lang]['infrastructure_card2_heading']}
                            </p>
                            <p>{variables[props.lang]['infrastructure_card2_text1']}</p>
                            <p>{variables[props.lang]['infrastructure_card2_text2']}</p>
                            <p>{variables[props.lang]['infrastructure_card2_text3']}</p>
                        </div>
                        <img alt={variables[props.lang]['infrastructure_card2_heading']} src={logo2}/>
                    </div>
                </div>
                <div className="row">
                    <div className="card">
                        <div className="left_content">
                            <p className="heading_text">
                                {variables[props.lang]['infrastructure_card3_heading']}
                            </p>
                            <p>{variables[props.lang]['infrastructure_card3_text1']}</p>
                            <p>{variables[props.lang]['infrastructure_card3_text2']}</p>
                            <p>{variables[props.lang]['infrastructure_card3_text3']}</p>
                        </div>
                        <img alt={variables[props.lang]['infrastructure_card3_heading']} src={logo3}/>
                    </div>
                    <div className="card">
                        <div className="left_content">
                            <p className="heading_text">
                                {variables[props.lang]['infrastructure_card4_heading']}
                            </p>
                            <p>{variables[props.lang]['infrastructure_card4_text1']}</p>
                            <p>{variables[props.lang]['infrastructure_card4_text2']}</p>
                            <p>{variables[props.lang]['infrastructure_card4_text3']}</p>
                        </div>
                        <img alt={variables[props.lang]['infrastructure_card4_heading']} src={logo4}/>
                    </div>
                </div>
            </div>
            <div className="link_row">
                <p>{variables[props.lang]['infrastructure_link_info']}</p>
                <Button className="secondary_button" variant="outlined" onClick={handleClick}>
                    <p>{variables[props.lang]['infrastructure_button']}</p>
                    <Icon className="arrow" icon="arrow"/>
                </Button>
            </div>
        </section>
    );
};

Infrastructure.propTypes = {
    lang: PropTypes.string.isRequired,
};

export default Infrastructure;
